import { FC } from 'react';

const DocumentationIcon: FC = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8711_4211)">
        <path
          d="M28.5949 9.81603C27.6572 8.87835 26.3855 8.35156 25.0594 8.35156H14.6087C12.887 8.35156 11.4783 9.76026 11.4783 11.482V36.5255C11.4783 38.2472 12.887 39.6559 14.6087 39.6559H33.3913C35.1131 39.6559 36.5218 38.2472 36.5218 36.5255V19.8139C36.5218 18.4879 35.995 17.2161 35.0573 16.2784L28.5949 9.81603ZM30.2609 31.8298C30.2609 32.6943 29.5601 33.395 28.6957 33.395H19.3044C18.4399 33.395 17.7391 32.6943 17.7391 31.8298C17.7391 30.9654 18.4399 30.2646 19.3044 30.2646H28.6957C29.5601 30.2646 30.2609 30.9654 30.2609 31.8298ZM30.2609 25.569C30.2609 26.4334 29.5601 27.1342 28.6957 27.1342H19.3044C18.4399 27.1342 17.7391 26.4334 17.7391 25.569C17.7391 24.7045 18.4399 24.0037 19.3044 24.0037H28.6957C29.5601 24.0037 30.2609 24.7045 30.2609 25.569Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8711_4211">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DocumentationIcon;
